import { isEmpty } from 'lodash-es';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { SectionInfo } from './SectionInfo';
import { insuranceDetailsContainerStyles } from './styles';

type PayerDetailsProps = {
  payerName: string;
  payerId: string;
};

export const PayerDetails = ({ payerId, payerName }: PayerDetailsProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  if (isEmpty(payerId) && isEmpty(payerName)) return null;

  return (
    <div css={insuranceDetailsContainerStyles}>
      <Heading level={3}>{t('Payer Details')}</Heading>
      <div css={{ marginTop: theme.spacing(1) }}>
        <SectionInfo label={t('Payer Name')} value={payerName || '-'} />
      </div>
      <div css={{ marginTop: theme.spacing(2) }}>
        <SectionInfo label={t('Payer ID')} value={payerId || '-'} />
      </div>
    </div>
  );
};
